<template>
  <div class="professional-picture-box">
    <a :href="'/cleaner/'+professional.id" target="_blank">
      <img v-lazy="professionalPicture()"
           class="rounded-circle"
           :class="imgClass"
           :width="imgSize">
    </a>
    <router-link to="/excellent-provider" target='_blank' v-if="professional.is_excellent === 1">
      <img src="/static/img/ic_badge_excellent.png"
           class="badge-excellent"
           :width="(badgeSize) ? badgeSize : '30%'"
           v-b-popover.hover.top="$i18n.t('message.professional.excellent_provider_detail', {name: firstName(professional)})"
           :title="$i18n.t('message.professional.excellent_provider_title')">
    </router-link>
  </div>
</template>

<script>
  export default {
    props: {
      professional: Object,
      imgClass: String,
      imgSize: Number,
      badgeSize: Number
    },
    methods: {
      professionalPicture () {
        let url = this.professional.picture
        if (this.professional.full_picture) {
          url = this.professional.full_picture
        }
        return url
      },
      firstName (professional) {
        let name = ''
        if (professional.firstname) {
          name = professional.firstname + ' ' + professional.lastname
        } else if (professional.name) {
          name = professional.name
        } else if (professional.full_name) {
          name = professional.full_name
        }

        if (name) {
          name = this.$options.filters.firstName(name)
        } else {
          name = this.$i18n.t('message.professional.this_provider')
        }

        return name
      },
      validUrl (str) {
        return str.startsWith('http')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/components/ProfessionalPicture.vue